import { composeIO } from 'react-compose-io'
import { itemControleComissaoPedidoIO } from './ItemControleComissaoPedido.IO'
import { ItemControleComissaoPedidoView } from './ItemControleComissaoPedido.View'

export const ItemControleComissaoPedido = composeIO(ItemControleComissaoPedidoView, itemControleComissaoPedidoIO)
